"use client"

import Carousel from "@/components/common/Carousel";
import { Col, Image, Row, RowProps } from "antd";
import { Fragment, useEffect, useRef, useState } from "react";
import SignupModal, { SignupModalRef } from "@/components/authen/signup/SignupModal";
import { CampaignBanner } from "@/lib/redux/features/flight/type";
import { useIsDesktop } from "@/hooks/app/useIsDesktop";
import PopupNewUser, { PopupNewUserRef } from "../home/PopupNewUser";
import ModalCharter, { ModalCharterRef } from "./ModalCharter";

const BannerDeals = ({ data, ...props }: RowProps & { data: CampaignBanner[] }) => {
  const refSignupModal = useRef<SignupModalRef>(null)
  const refPopupNewUser = useRef<PopupNewUserRef>(null)
  const refModalCharter = useRef<ModalCharterRef>(null)
  const [isReady, setIsReady] = useState(false)
  const [mobileSliderAspectRatio, setMobileSliderAspectRatio] = useState<string>()
  const isDesktop = useIsDesktop()

  const validBanners = data.map(campaign => ({
    alt: campaign.displayName,
    url: (isDesktop ? campaign.bannerDesktopUrl : campaign.bannerMobileUrl) || campaign.bannerDesktopUrl || campaign.bannerMobileUrl || "",
    onClick: () => {
      if (campaign.displayName === 'VE_BAY_TET_2026_DONG_GIA') {
        refModalCharter.current?.open()
        return
      }
      if (!!campaign?.subPopup[0]?.url) {
        refPopupNewUser.current?.open(
          campaign.subPopup[0]?.url
        )
      }
    },
  }))
    .filter(campaign => !!campaign.url)

  const featuredBanner = validBanners[0]
  const sliderBanners = validBanners.slice(1)
  const firstSliderBanner = sliderBanners[0]

  useEffect(() => {
    if (!featuredBanner) return

    let cancelled = false
    const urls = [featuredBanner.url, firstSliderBanner?.url].filter(Boolean)
    const timeoutId = window.setTimeout(() => {
      if (!cancelled) setIsReady(true)
    }, 8000)

    Promise.all(urls.map(url => new Promise<void>(resolve => {
      const image = new window.Image()
      const settle = () => {
        if (!isDesktop && url === firstSliderBanner?.url && image.naturalWidth && image.naturalHeight) {
          setMobileSliderAspectRatio(`${image.naturalWidth} / ${image.naturalHeight}`)
        }
        resolve()
      }

      image.onload = settle
      image.onerror = settle
      image.src = url

      if (image.complete) settle()
    }))).then(() => {
      if (!cancelled) setIsReady(true)
    })

    return () => {
      cancelled = true
      window.clearTimeout(timeoutId)
    }
  }, [featuredBanner?.url, firstSliderBanner?.url, isDesktop])

  if (!featuredBanner) return <Fragment />

  const isMultiSlide = sliderBanners.length > 1

  return (
    <Row {...props} className="home__deals-hotels--box" justify='center' style={{ padding: 0, marginBottom: '3rem', ...props.style }}>
      <Col span={24} className="home__deals--box" style={{ padding: 0 }}>
        <PopupNewUser autoOpen={false} ref={refPopupNewUser} />
        <SignupModal ref={refSignupModal} />
        <ModalCharter ref={refModalCharter} />
        <div className={`home__deals-banner-layout${isReady ? " is-ready" : ""}`}>
          <div className="home__deals-banner-featured" onClick={featuredBanner.onClick}>
            <Image
              preview={false}
              src={featuredBanner.url}
              alt={featuredBanner.alt}
              width="100%"
              loading="eager"
              fetchPriority="high"
              rootClassName="home__deals-banner-img"
            />
          </div>
          {sliderBanners.length > 0 && (
            <Carousel
              className="carousel-main home__deals-other--list home__deals-banner-carousel"
              style={!isDesktop && mobileSliderAspectRatio ? { aspectRatio: mobileSliderAspectRatio } : undefined}
              options={{
                pageDots: isMultiSlide,
                cellAlign: "left",
                contain: true,
                draggable: isMultiSlide,
                prevNextButtons: isMultiSlide,
                wrapAround: isMultiSlide,
                autoPlay: isMultiSlide ? 3000 : false,
                adaptiveHeight: !isDesktop,
                setGallerySize: !isDesktop,
              }}
            >
              {sliderBanners.map(({ url, alt, onClick }, idx) => (
                <div
                  key={`${idx}_${url}`}
                  className="flickity-container flickity-cell home__deals-banner-slide"
                  onClick={() => onClick?.()}
                >
                  <Image
                    preview={false}
                    src={url}
                    alt={alt}
                    loading={idx === 0 ? "eager" : "lazy"}
                    fetchPriority={idx === 0 ? "high" : "auto"}
                    rootClassName="home__deals-banner-img"
                  />
                </div>
              ))}
            </Carousel>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default BannerDeals;
